export default __webpack_public_path__ + "static/flag-de-2a68837a22fc3faa93aba6bf5043a2ce.svg";